import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ContactFolderList from '@contact/components/ContactFolderList.vue'
import MailFolderList from '@mail/components/MailFolderList.vue'

@Component({
    components: { ContactFolderList, MailFolderList }
})

export default class FolderList extends Vue {
}